import { getActiveAttestationsSigningAttestationsActiveGet } from '../../services/api/sdk.gen';
import type { ActiveAttestationsMap } from './attestations';

/**
 * Load active attestation copy from the API (source of truth).
 */
export async function fetchActiveAttestations(): Promise<ActiveAttestationsMap> {
  const { data } = await getActiveAttestationsSigningAttestationsActiveGet({
    throwOnError: true,
  });
  if (
    !data?.visit?.text ||
    !data?.missed_visit?.text ||
    !data?.order?.text ||
    !data?.cms485?.text ||
    !data?.medication?.text ||
    !data?.communication?.text ||
    !data?.misc?.text
  ) {
    throw new Error('Failed to load signing attestations');
  }
  return data;
}
